import { ConnectionRenderer } from "../abstract/ConnectionRenderer";
import { AbstractShape } from "../abstract/Shape";
import { ArrowStyle } from "../enums/ArrowType";
import { RelationDirection } from "../enums/RelationDirection";
import { conditionShow } from "../utils/ContainerUtils";
import { ShapeRefArray } from "./ShapeRefArray";
import { Values } from "./Values";

export class CreateConnectionArrow extends ConnectionRenderer{
    constructor(fromRef: ShapeRefArray, x2: number, y2: number){
        let from = fromRef.getShape()[0];
        if(!from)return;
        super("", from.id, "", from.x, from.y, x2, y2, from, undefined, "", "");
    }

    override draw(ctx: CanvasRenderingContext2D) {
        this.calculateScale(ctx);
        this.drawStraightArrowNoTo(ctx, this.iFrom);
    }
}